export const CONTACT = {
  phoneDisplay: "07469 148305",
  phoneRaw: "tel:+447469148305",
  email: "cohenyoch@yahoo.com",
  emailLink: "mailto:cohenyoch@yahoo.com",
  area: "Salford & surrounding areas",
  owner: "Y. C. Cohen",
  blessing: "\u05D1\u05E2\u05D6\u05E8\u05EA \u05D4\u05E9\u05DD \u05D9\u05EA\u05D1\u05E8\u05DA",
};

export const SERVICES = [
  {
    icon: "Hammer",
    title: "Joinery & Carpentry",
    desc: "Custom builds, kitchens, doors, flooring and clever storage \u2014 crafted to fit your space perfectly.",
    tags: ["Custom builds", "Kitchens", "Flooring", "Storage"],
    image: "/img/svc-joinery.jpg",
  },
  {
    icon: "Droplets",
    title: "Plumbing",
    desc: "Taps, leaks, toilets and appliance fittings sorted quickly and cleanly \u2014 first time, every time.",
    tags: ["Taps", "Leaks", "Toilets", "Appliances"],
    image: "/img/svc-plumbing-new.jpg",
  },
  {
    icon: "Zap",
    title: "Electrical",
    desc: "Lights, sockets, fans and appliance wiring installed safely and to a high standard.",
    tags: ["Lights", "Sockets", "Fans", "Appliances"],
    image: "/img/svc-electrical.jpg",
  },
  {
    icon: "Lightbulb",
    title: "Creative Home Projects",
    desc: "Space-saving ideas, feature walls and full room upgrades \u2014 we turn your vision into reality.",
    tags: ["Feature walls", "Room upgrades", "Space-saving"],
    image: "/img/svc-creative.jpg",
  },
  {
    icon: "Wrench",
    title: "General Handyman Work",
    desc: "Repairs, fittings and maintenance done with precision and care. No job too small.",
    tags: ["Repairs", "Fittings", "Maintenance"],
    image: "/img/svc-general.jpg",
  },
  {
    icon: "KeyRound",
    title: "Doors, Locks & PVC Tiling",
    desc: "Door hanging, lock changes, light extensions and PVC tiling \u2014 the finishing touches that matter.",
    tags: ["Doors", "Locks", "PVC tiling", "Light extensions"],
    image: "/img/svc-doors.jpg",
  },
];

export const JOBS = [
  { src: "/jobs/doors-french.jpg", title: "Glazed French Doors Hung", cat: "Joinery" },
  { src: "/jobs/job2.jpg", title: "Under-Stairs Storage Build", cat: "Joinery" },
  { src: "/jobs/job3.jpg", title: "Bespoke Storage Hatch", cat: "Joinery" },
  { src: "/jobs/job4.jpg", title: "Keypad Lock Installation", cat: "Locks & Security" },
  { src: "/jobs/job5.jpg", title: "Smart Door Lock Fitted", cat: "Locks & Security" },
  { src: "/jobs/fascia-soffit.jpg", title: "Fascia, Soffit & Cladding", cat: "General Handyman" },
];

export const BENEFITS = [
  "Perfection-focused workmanship",
  "Flexible scheduling around you",
  "Great customer understanding",
  "A genuinely wide range of skills",
  "Joinery, plumbing & electrical in one place",
  "No job too small \u2014 or too complicated",
];

export const IMAGES = {
  logo: "/img/logo.png",
  hero: "/img/hero.jpg",
  craftsman: "/img/craftsman.jpg",
  tools: "/img/tools.jpg",
};
